module.exports = __webpack_public_path__ + "static/media/cowcropped.28535187.gif";